import React from 'react';
import icCheck1 from 'Assets/img/sign/ic_check_circle_blue.png';
import icCheck2 from 'Assets/img/sign/ic_check_circle_blue@2x.png';
import icCheck3 from 'Assets/img/sign/ic_check_circle_blue@3x.png';
import { getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';
import BasicButton from '../../common/BasicButton';

const icCheck = getImageSet([icCheck1, icCheck2, icCheck3]);

const PasswordCompleteSection = ({ onChangeLogin }) => {
  return (
    <div className="inner-container" style={{ paddingLeft: '20px', paddingRight: '20px', gap: '80px' }}>
      <div className="join-complete-wrapper">
        <img {...icCheck} alt="check" />
        <span className="join-complete-title">
          <IntlMessages id="signIn.join.findPassword.complete.title" />
        </span>
        <div className="join-complete-contents">
          <IntlMessages id="signIn.join.findPassword.complete.sub" />
        </div>
      </div>
      <BasicButton
        label="sign.title"
        onClick={() => {
          onChangeLogin();
        }}
        style={{ backgroundColor: '#0567F9' }}
      />
    </div>
  );
};

export default PasswordCompleteSection;
